export default __webpack_public_path__ + "ffbec3d38118926d3d8c0e495fc6cdf9.png";